import WSInternalEvent from '../utils/helpers/ws-internal-event';

const dragstartListener = (liveDocument) => {
  const listener = WSInternalEvent.bind(null, (event) => {
    event.preventDefault();
  });

  liveDocument.addEventListener('dragstart', listener);
};

export default dragstartListener;
